import AllReceiptsTable from './components/AllReceiptsTable';

export default AllReceiptsTable;
